import { useMemo } from 'react';
import { useFormWatch } from '../../../../../helpers/formManager';
import { fieldNames } from '../constants';

const labels = {
  [fieldNames.name]: { validate: 'Наименование', required: 'наименование' },
  [fieldNames.description]: { validate: 'Описание', required: 'описание' },
};

export const useAttachmentDependentFieldConfig = ({
  name,
  maxSize,
  isRequired = true,
}) => {
  const attachments = useFormWatch({
    name: fieldNames.files,
    defaultValue: [],
  });

  const hasMultipleAttachments = attachments?.length > 1;

  return useMemo(() => {
    return {
      rules: {
        required:
          !hasMultipleAttachments && isRequired
            ? `Укажите ${labels[name].required}`
            : false,
        validate: hasMultipleAttachments
          ? undefined
          : createValidate({ name, maxSize }),
      },
      disabled: hasMultipleAttachments,
    };
  }, [hasMultipleAttachments, name, maxSize, isRequired]);
};

function createValidate({ name, maxSize }) {
  return (value) => {
    if (value?.length > maxSize) {
      return `${labels[name].validate} должно быть не больше ${maxSize} символов`;
    }
  };
}
